import { useEffect } from "react";

export const useMutationObserver = (
    ref: React.RefObject<HTMLElement> | undefined,
    callback?: MutationCallback,
    options: MutationObserverInit = {
        attributes: true,
        childList: true,
        subtree: true,
    },
) => {
    useEffect(() => {
        if (!ref || !ref.current || !callback) return;
        const observer = new MutationObserver(callback);
        observer.observe(ref.current, options);

        return () => observer.disconnect();
    }, [ref, callback, options]);
};
